<template>
    <div>
        <RequestGrid v-if="$helper.permission.canSeeRequest(user)" @forceUpdate="key++" :key="key"></RequestGrid>
        <AppointmentsGrid v-if="$helper.permission.canSeeAppointments(user)" @forceUpdate="key++" :key="key"></AppointmentsGrid>
        <ClientGrid v-if="$helper.permission.canSeeClientOnMain(user)" @forceUpdate="key++" :key="key"></ClientGrid>
        <ContractGrid v-if="$helper.permission.canSeeContractsOnMain(user)" @forceUpdate="key++" :key="key"></ContractGrid>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import RequestGrid from "../requests/RequestGrid";
    import AppointmentsGrid from "../appointments/AppointmentsGrid";
    import ClientGrid from "../clients/ClientGrid";
    import ContractGrid from "../contracts/ContractGrid";

    export default {
        name: 'HomePage',
        components: {ContractGrid, ClientGrid, AppointmentsGrid, RequestGrid},
        data() {
            return {
                key: 0
            }
        },
        computed: {
            ...mapState(['user'])
        },
    };
</script>
